export function convertToCSSVariables(obj, prefix = '') {
    const properties = {};
    Object.entries(obj).map(([key, value]) => {
        const name = toCSSVarCase(key, prefix);
        if (isObject(value)) {
            const flattenedValues = convertToCSSVariables(value, name);
            Object.entries(flattenedValues).map(([nestedName, nestedValue]) => {
                properties[`${nestedName}`] = nestedValue;
            });
        }
        else {
            // No need to add quotes for list values, as css properties don't really like them
            properties[`--${name}`] = value;
        }
    });
    return properties;
}
/**
 * Converts a given string to common CSS variable case (kebab-case) without the leading double dash.
 *
 * @example
 * toCSSVarCase('cssVariable') // -> 'css-variable'
 *
 * toCSSVarCase('cssVariable', 'my') // -> 'my-css-variable'

 * toCSSVarCase('css.variable', 'my', '.')  // -> 'my-css-variable'
 *
 * @param str input text
 * @param prefix optional prefix inserted at the beginning of the string
 * @param separator additional word separator which will "break" words with a dash
 * @returns string suitable for css variable usage (without the leading double-dash).
 */
export function toCSSVarCase(str, prefix = '', separator) {
    let characters = [...str];
    characters.map((char, i) => {
        if (separator && char === separator) {
            characters[i] = '-';
        }
        else if (char === char.toUpperCase() && !isNumber(char)) {
            characters[i] = `-${char.toLowerCase()}`;
        }
    });
    if (prefix) {
        const dash = characters[0].startsWith('-') ? '' : '-';
        return `${prefix}${dash}${characters.join('')}`;
    }
    return characters.join('');
}
const isNumber = (char) => !isNaN(Number(char));
const isObject = (variable) => Object.prototype.toString.call(variable) === '[object Object]';
